import moment from "moment";
import { eventName as event } from "../constants/events/eventName";
import { FLOW_TYPE, PASSENGER_TYPE_NAME, SEAT_SELECTION_SSRCODE } from "../constants/variables";
import { bookingIniatedFrom, bookingType } from "../store/slices/booking";
import { adhosName } from "./addons/addons";
import { flightDetails } from "./trackUserActivity";

const ONLY_DATE_FORMAT = "YYYY-MM-DD";
const md5 = require("md5");

export function convertPriceToNumber(price) {
  if (price) {
    return parseFloat(price.split(",").join("").split("₹").join(""));
  }
}

const ga4EventList = {
  FB_FlightSearched: "search_item",
  Flight_Selected: "select_item",
  Flight_booking_initiated: "add_to_cart",
  Flight_Payment_initiated: "begin_checkout",
  FB_Successful: "purchase",
  Flight_list: "view_item_list"
};
const ONE_WAY = "Flight-Oneway-standard";
const ROUND_TRIP = "Flight-Roundtrip-standard";
const ITEM_NAME_SEAT_SELECTION = "seat_selection";
const LOGIN_USER = "Logged-in";
const GUEST_USER = "GUEST";
const DATE_FORMAT = "YYYY-MM-DD";
export const pageSection = {
  MANAGE_BOOKING: "Manage-booking",
  FLIGHT_BOOKING: "Flight-booking",
  CHECK_IN: "Check-in"
};

export function flightItemName(flightDetails) {
  let textToReturn = "Flight-";
  if (flightDetails.tripType === "ONE_WAY") {
    textToReturn += "Oneway-";
  } else {
    textToReturn += "Roundtrip-";
  }

  if (
    flightDetails?.flightDetails.totalFares[flightDetails.brandFareIndex[flightDetails.flightDetails.journeyIndexKey]]
      .productClass === "EC"
  ) {
    textToReturn += "Saver";
  } else {
    textToReturn += "Flexi";
  }
  return textToReturn;
}

export function flightItemNameAfterBooking(flightDetails, journeyDetails, journeyInd) {
  let textToReturn = "Flight-";
  if (flightDetails.tripType === "ONE_WAY") {
    textToReturn += "Oneway-";
  } else {
    textToReturn += "Roundtrip-";
  }
  if (journeyDetails?.totalFares[flightDetails.brandFareIndex[journeyInd]].productClass === "EC") {
    textToReturn += "Saver";
  } else {
    textToReturn += "Flexi";
  }
  return textToReturn;
}

export function getFlightNameWithProductClassType(journey) {
  try {
    let textToReturn = "Flight-";
    if (journey && journey.length === 1) {
      textToReturn += "Oneway-";
    } else {
      textToReturn += "Roundtrip-";
    }
    let productClassName = "";
    for (let ind = 0; ind < journey.length; ind += 1) {
      const currentJourney = journey[ind];
      if (currentJourney.segments && currentJourney.segments.length > 0) {
        productClassName = currentJourney.segments[0]?.fares?.[0]?.productClass;
      }
    }

    if (productClassName === "EC") {
      textToReturn += "Saver";
    } else {
      textToReturn += "Flexi";
    }
    return textToReturn;
  } catch (error) {
    console.warn(error);
  }
}

export function getFlightPriceForOnePax(currentFlight, brandFareIndex, journeyInd) {
  const response = {
    price: 0,
    discount: 0
  };
  try {
    const passengerFare = currentFlight.passengerFare[brandFareIndex[journeyInd]];
    Object.keys(passengerFare).forEach((key, index) => {
      if (index === 0) {
        response.price = passengerFare[key]?.amount - currentFlight.subtractAmount.singlePax;
        response.discount = passengerFare[key]?.publishedFare - passengerFare[key]?.discountedFare;
      }
    });
    return response;
  } catch (error) {
    console.warn(error);
  }
}
export function getPageSection(details) {
  if (details?.currentBookingV2?.bookingType === bookingType.CHANGE_BOOKING) {
    return pageSection.MANAGE_BOOKING;
  }
  if (details?.currentBookingV2) {
    if (details?.currentBookingV2.bookingIniatedFrom == bookingIniatedFrom.MANAGE_BOOKING) {
      return pageSection.MANAGE_BOOKING;
    }
    if (details?.currentBookingV2.bookingIniatedFrom == bookingIniatedFrom.NEW_BOOKING) {
      return pageSection.FLIGHT_BOOKING;
    }
  }
  if (!details?.flowType) {
    if (details?.isChangeBooking) {
      return pageSection.MANAGE_BOOKING;
    }
    return pageSection.FLIGHT_BOOKING;
  }
  if (details?.flowType === FLOW_TYPE.MANAGE_BOOKING) {
    return pageSection.MANAGE_BOOKING;
  }
  if (details?.flowType === FLOW_TYPE.CHECK_IN) {
    return pageSection.CHECK_IN;
  }
}

export function getGenderCount(bookingInState) {
  try {
    const response = {
      male: 0,
      female: 0
    };
    for (let index = 0; index < bookingInState?.passengers.length; index++) {
      const paxInfo = bookingInState?.passengers[index];
      if (paxInfo?.value?.info?.gender === "Male") {
        response.male += 1;
      } else {
        response.female += 1;
      }
    }
    return response;
  } catch (error) {}
}

export function getOnlyFlightPrice(bookingSummary) {
  try {
    let allPaxPrice = 0;
    let paxCount = 0;
    Object.keys(bookingSummary).map((key, index) => {
      if (PASSENGER_TYPE_NAME[key]) {
        allPaxPrice += bookingSummary[key]?.farePrice?.amount;
        paxCount += bookingSummary[key]?.farePrice?.count;
      }
    });
    return { price: allPaxPrice, quantity: paxCount };
  } catch (error) {
    console.warn(error);
  }
}
export function getOnlyFlightPriceWithoutTax(details) {
  try {
    let flightTotal = 0;
    const bookingSummaryBreakUp = details?.bookingSummaryBreakUp;
    if (bookingSummaryBreakUp) {
      Object.entries(bookingSummaryBreakUp).map(([key, value], i) => {
        if (PASSENGER_TYPE_NAME[key]) {
          flightTotal +=
            bookingSummaryBreakUp[key]?.farePrice.amount * bookingSummaryBreakUp[key]?.farePrice.count ?? 0;
        }
      });
    }
    return flightTotal;
  } catch (error) {
    console.warn(error);
  }
}

export function restructureObj(eventName, details) {
  let eventArray = {};
  if (window) {
    eventArray.pageurl = window.location.pathname;
  }
  if (eventName === event.FLIGHT_SEARCH) {
    eventArray.event = ga4EventList[event.FLIGHT_SEARCH];
    (eventArray.FlightDetail = {
      departureCity: details?.origin?.stationCode,
      arrivalCity: details?.destination?.stationCode,
      flight_type: details?.tripType,
      depart_date: moment(details?.departureDate).format(ONLY_DATE_FORMAT),
      return_date: moment(details?.arrivalDate).format(ONLY_DATE_FORMAT),
      special_fare: details?.specialFare?.name,
      noOfAdults: details?.passenger?.adult,
      noOfChildren: details?.passenger?.child,
      noOfInfants: details?.passenger?.infant,
      seniorCitizen: details?.passenger?.seniorcitizen,
      totalPassengers: details?.passenger?.total
    }),
      (eventArray.ecommerce = {
        items: [
          {
            item_id: `${details?.origin?.stationCode}-${details?.destination?.stationCode}`,
            currency: details?.selectedCurrency
          }
        ]
      });
  }
  if (eventName === event.FLIGHT_SELECT) {
    eventArray.event = ga4EventList[event.FLIGHT_SELECT];
    eventArray.FlightDetail = {
      flight_number: details?.flightDetails?.flightNumbers ? details?.flightDetails?.flightNumbers[0] : "",
      depart_date: moment(details?.departureDate).format(ONLY_DATE_FORMAT),
      arrival_date: moment(details?.arrivalDate).format(ONLY_DATE_FORMAT),
      layover_airport_destination: "",
      layover_duration: details?.flightDetails?.duration,
      total_price: convertPriceToNumber(details?.flightDetails?.displayFare?.totalDisplayFare),
      currency: details?.selectedCurrency,
      seats_available: 3, // currently hard-codin,
      tag: "",
      flight_duration: details?.duration,
      search_passenger_count: details?.passenger?.total,
      tags: "",
      noOfAdults: details?.passenger?.adult,
      noOfChildren: details?.passenger?.child,
      noOfInfants: details?.passenger?.infant,
      seniorCitizen: details?.passenger?.seniorcitizen,
      totalPassengers: details?.passenger?.total,
      departureCity: details?.flightDetails?.originStation,
      arrivalCity: details?.flightDetails?.destinationStation,
      pageSection: getPageSection(details)
    };
    eventArray.ecommerce = {
      items: [
        {
          item_id: `${details?.flightDetails?.originStation} - ${details?.flightDetails?.destinationStation}`,
          item_name: flightItemName(details),
          // depart_date:  moment(details?.departureDate).format(DATE_FORMAT),
          // arrival_date:  moment(details?.arrivalDate).format(DATE_FORMAT),
          // layover_airport_destination:  "",
          // layover_duration:  details?.flightDetails?.duration,
          price: convertPriceToNumber(details?.flightDetails?.displayFare?.totalDisplayFare),
          discount:
            parseInt(convertPriceToNumber(details?.flightDetails?.displayFare?.totalDisplayFare), 10) -
            parseInt(convertPriceToNumber(details?.flightDetails?.displayFare?.discountedDisplayFare), 10),
          currency: details?.selectedCurrency,
          seats_available: 3, // currently hard-codin,
          tag: "",
          // flight_duration:  details?.duration,
          // search_passenger_count:  details?.passenger?.total,
          // tags:  "",
          item_category: "Flight"
        }
      ]
    };
    if (details.user) {
      eventArray.FlightDetail.customerId = details.user.cusExternalId;
      eventArray.FlightDetail.userType = LOGIN_USER;
      eventArray.FlightDetail.encryptedEmailId = md5(details.user.cusEmail);
      eventArray.FlightDetail.encryptedMobileNumber = md5(details.user.cusMobile);
      eventArray.FlightDetail.emailId = details.user.cusEmail; // no encryption
      eventArray.FlightDetail.mobileNumber = details.user.cusMobile; // no encryption
      // eventArray['FlightDetail']['special_fare'] =  'Dynamic';
      // eventArray['FlightDetail']['special_assistance'] =  'Dynamic';
    } else {
      eventArray.FlightDetail.userType = GUEST_USER;
    }
    if (details.selectedSpecialFare) {
      eventArray.FlightDetail.special_fare = details.selectedSpecialFare?.name;
    }
    return eventArray;
  }
  if (eventName === event.FLIGHT_LISTING) {
    const itemArray = [];
    const tempJourneyDetails = details.response;
    const journeyType = tempJourneyDetails.length > 1 ? ROUND_TRIP : ONE_WAY;
    let ind = 0;

    for (let journeyInd = 0; journeyInd < tempJourneyDetails.length; journeyInd++) {
      for (let index = 0; index < tempJourneyDetails[journeyInd].length; index++) {
        const currentFlight = tempJourneyDetails[journeyInd][index];
        const price = getFlightPriceForOnePax(currentFlight, details.brandFareIndex, journeyInd);
        const itemObj = {};
        itemObj.item_id = `${currentFlight?.originStation} - ${currentFlight?.destinationStation}`;
        itemObj.item_name = journeyType;
        itemObj.item_category = "Flight";
        itemObj.index = ind += 1;
        itemObj.discount = parseInt(price.discount, 10);
        itemObj.item_list_name = currentFlight?.flightNumbers?.[0];
        itemObj.price = parseInt(price.price, 10);
        itemObj.currency = details?.selectedCurrency;

        itemArray.push(itemObj);
      }
    }
    eventArray.FlightDetail = {
      depart_date: moment(details.departureDateInState).format(ONLY_DATE_FORMAT), // Custom dimension
      return_date: details?.tripType === "ONE_WAY" ? "" : moment(details.arrivalDateInState).format(ONLY_DATE_FORMAT), // Custom dimension
      departureCity: details.origin, // Custom dimension
      arrivalCity: details.destination, // Custom dimension
      noOfAdults: details.passenger.adult, // Custom Metrics
      noOfChildren: details.passenger.child, // Custom metrics
      noOfInfants: details.passenger.infant, // Custom metrics
      seniorCitizen: details.passenger.seniorcitizen, // Custom metrics
      pageSection: getPageSection(details)
    };
    if (details.user) {
      eventArray.FlightDetail.customerId = details.user.cusExternalId;
      eventArray.FlightDetail.userType = "Logged-in";
      eventArray.FlightDetail.encryptedEmailId = md5(details.user.cusEmail);
      eventArray.FlightDetail.encryptedMobileNumber = md5(details.user.cusMobile);
      eventArray.FlightDetail.emailId = details.user.cusEmail; // no encryption
      eventArray.FlightDetail.mobileNumber = details.user.cusMobile; // no encryption
      // eventArray['FlightDetail']['special_fare'] =  'Dynamic';
      // eventArray['FlightDetail']['special_assistance'] =  'Dynamic';
    } else {
      eventArray.FlightDetail.customerId = "";
      eventArray.FlightDetail.userType = "GUEST";
      eventArray.FlightDetail.encryptedEmailId = "";
      eventArray.FlightDetail.encryptedMobileNumber = "";
      eventArray.FlightDetail.emailId = ""; // no encryption
      eventArray.FlightDetail.mobileNumber = ""; // no encryption
    }
    if (details.selectedSpecialFare) {
      eventArray.FlightDetail.special_fare = details.selectedSpecialFare?.name;
    }

    eventArray.event = ga4EventList[event.FLIGHT_LISTING];
    eventArray.ecommerce = {
      items: itemArray
    };

    if (!details.destination) {
      eventArray = [];
    }
    return eventArray;
  }
  if (eventName === event.BOOKING_INITIATED) {
    eventArray.event = ga4EventList[event.BOOKING_INITIATED]; // "add_to_cart",
    const itemArray = [];
    for (let journeyInd = 0; journeyInd < details.journeyWatcher.length; journeyInd++) {
      const itemObj = {};
      const journeyDetails = details.journeyWatcher[journeyInd];
      itemObj.item_id = `${journeyDetails.originStation} - ${journeyDetails.destinationStation}`;
      itemObj.item_name = flightItemNameAfterBooking(details, journeyDetails, journeyInd);
      itemObj.item_category = "Flight";
      itemObj.discount =
        parseInt(convertPriceToNumber(journeyDetails?.displayFare?.totalDisplayFare), 10) -
        parseInt(convertPriceToNumber(journeyDetails?.displayFare?.discountedDisplayFare), 10);
      // itemObj['item_list_name'] = journeyDetails?.flightNumbers?.[0];
      itemObj.price = convertPriceToNumber(journeyDetails?.displayFare?.totalDisplayFare);
      itemObj.currency = details?.selectedCurrency;
      itemArray.push(itemObj);
    }
    (eventArray.FlightDetail = {
      departureCity: details?.origin?.stationCode,
      arrivalCity: details?.destination?.stationCode,
      flight_type: details?.tripType,
      depart_date: moment(details?.departureDate).format(ONLY_DATE_FORMAT),
      return_date: moment(details?.arrivalDate).format(ONLY_DATE_FORMAT),
      special_fare: details?.specialFare?.name,
      noOfAdults: details?.passenger?.adult,
      noOfChildren: details?.passenger?.child,
      noOfInfants: details?.passenger?.infant,
      seniorCitizen: details?.passenger?.seniorcitizen,
      totalPassengers: details?.passenger?.total,
      pageSection: getPageSection(details)
    }),
      (eventArray.ecommerce = {
        items: itemArray
      });
    if (details.user) {
      eventArray.FlightDetail.customerId = details.user.cusExternalId;
      eventArray.FlightDetail.userType = LOGIN_USER;
      eventArray.FlightDetail.encryptedEmailId = md5(details.user.cusEmail);
      eventArray.FlightDetail.encryptedMobileNumber = md5(details.user.cusMobile);
      eventArray.FlightDetail.emailId = details.user.cusEmail; // no encryption
      eventArray.FlightDetail.mobileNumber = details.user.cusMobile; // no encryption
      // eventArray['FlightDetail']['special_fare'] =  'Dynamic';
      // eventArray['FlightDetail']['special_assistance'] =  'Dynamic';
    } else {
      eventArray.FlightDetail.userType = GUEST_USER;
    }
    return eventArray;
  }
  if (eventName === event.ADD_PAX_DETAILS) {
    eventArray.event = event.ADD_PAX_DETAILS;
    eventArray["Special Assistance"] = false;
    eventArray.Mobility = "NA";
    eventArray.Impairments = "NA";
    // 'customerId' = 'NA';
    eventArray.emailId = details?.contact?.emailAddress;
    eventArray.mobile_number = details?.contact?.phoneNumbers[0]?.number;
    eventArray["overall Details"] = [{ ...details }];
    eventArray["special assistance for n.o traveller"] = 0;
  }
  if (eventName === event.ADDONS_SELECTED) {
    eventArray.event = event.ADDONS_SELECTED;
    eventArray.excess_baggage_added = "NA";
    eventArray.meals_added = "NA";
    eventArray.akasa_flex_added = "NA";
    eventArray["priority_check-in_added"] = "NA";
    eventArray.priority_boarding_added = "NA";
    eventArray.lounge_access_added = "NA";
    eventArray.flight_delay_cover_added = "NA";
    eventArray.cancellation_cover_added = "NA";
    eventArray["lost/delayed_bag_added"] = "NA";
    eventArray.flight_delay_cover_added = "NA";
    eventArray["overall Details"] = "NA";
    eventArray.flexi_cover_added = "NA";
    eventArray.trip_cover_added = "NA";
    eventArray.total_added = "NA";
    eventArray.total_addon_price = "NA";
    eventArray.skipped = details?.skip;
  }
  if (eventName === event.FLIGHT_SEAT_SELECTED) {
    eventArray.event = "add_to_cart";
    const tempSeatSelectedArray = [];
    const tripType = details.bookingInState.journeys.length === 1 ? ONE_WAY : ROUND_TRIP;
    let origin = "";
    let destination = "";
    let arrivalDate = "";
    let departureDate = "";
    let flightName = "";

    if (details?.bookingInState?.journeys && details?.bookingInState?.journeys.length > 0) {
      origin = details?.bookingInState?.journeys[0].designator?.origin;
      destination = details?.bookingInState?.journeys[0].designator?.destination;
      arrivalDate = details?.bookingInState?.journeys[0].designator?.arrival;
      departureDate = details?.bookingInState?.journeys[0].designator?.departure;

      if (details?.bookingInState?.journeys[0]?.segments && details?.bookingInState?.journeys[0]?.segments.length > 0) {
        flightName =
          details?.bookingInState?.journeys[0]?.segments[0]?.identifier.carrierCode +
          details?.bookingInState?.journeys[0]?.segments[0]?.identifier.identifier;
      }
    }
    const items = [];

    for (let tempInd = 0; tempInd < details?.seatSelectedWithPassenger.length; tempInd++) {
      const currentSeat = details?.seatSelectedWithPassenger[tempInd];
      const itemObj = {};
      itemObj.item_id = `${origin} - ${destination}`;
      itemObj.item_name = ITEM_NAME_SEAT_SELECTION;
      itemObj.item_category = "Flight";
      itemObj.discount = 0;
      itemObj.item_list_name = flightName;
      itemObj.price = currentSeat?.seatPrice;
      itemObj.currency = details?.selectedCurrency;
      items.push(itemObj);
    }
    eventArray.ecommerce = {
      items
    };
    eventArray.seat_no = details?.seatSelectedWithPassenger?.map((o) => o.designator)?.join(",");
    eventArray.total_no_seats = details?.seatSelectedWithPassenger?.length;
    eventArray.total_seat_price = details?.seatSelectedWithPassenger
      ?.map((o) => o.seatPrice)
      ?.reduce((previousValue, currentValue) => previousValue + currentValue, 0);
    eventArray.currency = details?.selectedCurrency;
    // return eventArray
  }
  if (eventName === event.PAYMENT_INITIATED) {
    eventArray.event = ga4EventList[event.PAYMENT_INITIATED]; // begin_checkout"
    eventArray.orderId = details?.orderId;
    eventArray.amount = details?.amount;
    let couponeCode = "";
    const itemArray = [];
    let discountAmount = 0;
    let index = 0;
    let od = "";
    let flightKey = "";
    Object.keys(details.bookingSummaryTemp).map((key, index) => {
      if (flightKey === "") {
        flightKey = key;
      }
      if (details.bookingSummaryBreakUp.Discount) {
        Object.keys(details.bookingSummaryBreakUp.Discount).map((key, index) => {
          discountAmount += details.bookingSummaryBreakUp.Discount[key].amount;
          couponeCode += `,${key}`;
        });
      }
      if (od === "") {
        od = key;
      }
    });

    itemArray.push({
      item_id: od,
      item_name: getFlightNameWithProductClassType(details?.currentBooking?.journeys),
      discount: discountAmount,
      price: getOnlyFlightPriceWithoutTax(details),
      item_category: "Flight",
      currency: details?.selectedCurrency,
      coupon: couponeCode,
      index: index++
    });

    if (details.bookingSummaryBreakUp.ADHONS) {
      Object.keys(details.bookingSummaryBreakUp.ADHONS).map((key, index) => {
        let item_name = details.bookingSummaryBreakUp.ADHONS[key].ssrCode;
        let item_id = key;
        let isSeatAdhos = false;
        if (details.bookingSummaryBreakUp.ADHONS[key]?.details?.name) {
          item_name = details.bookingSummaryBreakUp.ADHONS[key]?.details?.name;
        } else if (details.bookingSummaryBreakUp.ADHONS[key]?.details?.title) {
          item_name = details.bookingSummaryBreakUp.ADHONS[key]?.details?.title;
        }
        if (details.bookingSummaryBreakUp.ADHONS[key].code == SEAT_SELECTION_SSRCODE) {
          item_name = "Seat";
          item_id = details.passengerSummary[0];
          isSeatAdhos = true;
        }
        if (isSeatAdhos) {
          if (!details.bookingSummaryBreakUp.ADHONS[key].isConfirmed) {
            // in case of false, only we should add it
            itemArray.push({
              item_id: flightKey,
              item_name: "Seat",
              discount: 0,
              price: details.bookingSummaryBreakUp.ADHONS[key].amount,
              item_category: "Addon",
              currency: details?.selectedCurrency,
              coupon: "",
              quantity: details.bookingSummaryBreakUp.ADHONS[key].count,
              index: index++
            });
          }
        } else if (!details.bookingSummaryBreakUp.ADHONS[key].isConfirmed) {
          // in case of false, only we should add it
          itemArray.push({
            item_id,
            item_name: adhosName(item_id),
            discount: 0,
            price: details.bookingSummaryBreakUp.ADHONS[key].amount,
            item_category: "Addon",
            currency: details?.selectedCurrency,
            coupon: "",
            quantity: details.bookingSummaryBreakUp.ADHONS[key].count,
            index: index++
          });
        }

        // discountAmount += details.bookingSummaryBreakUp['ADHONS'][key]['amount'];
      });
    }
    eventArray.ecommerce = {
      items: itemArray
    };

    const genderCount = getGenderCount(details?.currentBooking);
    eventArray.FlightDetail = flightDetails(details?.currentBooking, "", details?.bookingInRedux);
    if (details.user) {
      eventArray.FlightDetail.customerId = details.user.cusExternalId;
      eventArray.FlightDetail.userType = LOGIN_USER;
      eventArray.FlightDetail.encryptedEmailId = md5(details.user.cusEmail);
      eventArray.FlightDetail.encryptedMobileNumber = md5(details.user.cusMobile);
      eventArray.FlightDetail.emailId = details.user.cusEmail; // no encryption
      eventArray.FlightDetail.mobileNumber = details.user.cusMobile; // no encryption
      // eventArray['FlightDetail']['special_fare'] =  'Dynamic';
      // eventArray['FlightDetail']['special_assistance'] =  'Dynamic';
    } else {
      eventArray.FlightDetail.userType = GUEST_USER;
    }
    eventArray.ecommerce = {
      items: itemArray
    };
    return eventArray;
  }
  if (
    eventName === event.BOOKING_SUCCESSFUL ||
    eventName === event.MANAGE_BOOKING_ADDONS_ADDED ||
    eventName === event.CHECKIN_SUCCESSFULL
  ) {
    // MB_BookingUpdate
    let couponeCode = "";
    const itemArray = [];
    eventArray.event = ga4EventList.FB_Successful;
    let flightKey = "";
    let discountAmount = 0;
    let index = 0;
    Object.keys(details.passengerSummary).map((key, index) => {
      if (flightKey === "") {
        flightKey = key;
      }

      if (details.bookingSummaryBreakUp.Discount) {
        Object.keys(details.bookingSummaryBreakUp.Discount).map((key, index) => {
          discountAmount += details.bookingSummaryBreakUp.Discount[key].amount;
          couponeCode += `,${key}`;
        });
      }
    });
    if (eventName === event.BOOKING_SUCCESSFUL) {
      itemArray.push({
        item_id: flightKey,
        item_name: getFlightNameWithProductClassType(details.bookingInState.journeys),
        discount: discountAmount,
        price: getOnlyFlightPriceWithoutTax(details),
        quantity: getOnlyFlightPrice(details.bookingSummaryBreakUp).quantity,
        item_category: "Flight",
        currency: details?.selectedCurrency,
        coupon: couponeCode,
        index: index++
      });
    }

    if (details.bookingSummaryBreakUp.ADHONS) {
      Object.keys(details.bookingSummaryBreakUp.ADHONS).map((key, index) => {
        let item_name = details.bookingSummaryBreakUp.ADHONS[key].ssrCode;
        let item_id = key;
        let isSeatAdhos = false;
        if (details.bookingSummaryBreakUp.ADHONS[key]?.details?.name) {
          item_name = details.bookingSummaryBreakUp.ADHONS[key]?.details?.name;
        } else if (details.bookingSummaryBreakUp.ADHONS[key]?.details?.title) {
          item_name = details.bookingSummaryBreakUp.ADHONS[key]?.details?.title;
        }
        if (details.bookingSummaryBreakUp.ADHONS[key].code == SEAT_SELECTION_SSRCODE) {
          item_name = "Seat";
          item_id = details.passengerSummary[0];
          isSeatAdhos = true;
        }
        if (isSeatAdhos) {
          if (!details.bookingSummaryBreakUp.ADHONS[key].isConfirmed) {
            // in case of false, only we should add it
            itemArray.push({
              item_id: flightKey,
              item_name: "Seat",
              discount: 0,
              price: details.bookingSummaryBreakUp.ADHONS[key].amount,
              item_category: "Addon",
              currency: details?.selectedCurrency,
              coupon: "",
              quantity: details.bookingSummaryBreakUp.ADHONS[key].count,
              index: index++
            });
          }
        } else if (!details.bookingSummaryBreakUp.ADHONS[key].isConfirmed) {
          // in case of false, only we should add it
          itemArray.push({
            item_id,
            item_name: adhosName(item_id),
            discount: 0,
            price: details.bookingSummaryBreakUp.ADHONS[key].amount,
            item_category: "Addon",
            currency: details?.selectedCurrency,
            coupon: "",
            quantity: details.bookingSummaryBreakUp.ADHONS[key].count,
            index: index++
          });
        }

        // discountAmount += details.bookingSummaryBreakUp['ADHONS'][key]['amount'];
      });
    }
    eventArray.ecommerce = {
      items: itemArray
    };
    if (eventName === event.BOOKING_SUCCESSFUL) {
      eventArray.ecommerce.transaction_id = `FB-${details.bookingInState.recordLocator}`;
    } else if (eventName === event.CHECKIN_SUCCESSFULL) {
      eventArray.ecommerce.transaction_id = `CH-${details.bookingInState.recordLocator}`;
    } else {
      eventArray.ecommerce.transaction_id = `MB-${details.bookingInState.recordLocator}`;
    }
    if (details?.isChangeBooking) {
      eventArray.ecommerce.transaction_id = `MB-${details.bookingInState.recordLocator}`;
    }

    eventArray.ecommerce.value = details.balanceAmount;
    eventArray.ecommerce.currency = details?.selectedCurrency;
    eventArray.ecommerce.coupon = couponeCode;
    const genderCount = getGenderCount(details?.bookingInState);
    eventArray.FlightDetail = {
      departureCity: details?.bookingInState?.journeys[0]?.designator?.origin,
      arrivalCity: details?.bookingInState?.journeys[0]?.designator?.destination,
      flight_type: getFlightNameWithProductClassType(details?.bookingInState?.journeys),
      depart_date: moment(details?.bookingInState?.journeys[0]?.designator?.departure).format(ONLY_DATE_FORMAT),
      return_date: moment(details?.bookingInState?.journeys[0]?.designator?.arrival).format(ONLY_DATE_FORMAT),
      special_fare: details?.specialFare?.name,
      noOfAdults: details?.passenger?.adult,
      noOfChildren: details?.passenger?.child,
      noOfInfants: details?.passenger?.infant,
      seniorCitizen: details?.passenger?.seniorcitizen,
      totalPassengers: details?.passenger?.total,
      male: genderCount.male,
      female: genderCount.female,
      pageSection: getPageSection(details),
      pnr: details.bookingInState.recordLocator
    };
    if (details.user) {
      eventArray.FlightDetail.customerId = details.user.cusExternalId;
      eventArray.FlightDetail.userType = LOGIN_USER;
      eventArray.FlightDetail.encryptedEmailId = md5(details.user.cusEmail);
      eventArray.FlightDetail.encryptedMobileNumber = md5(details.user.cusMobile);
      eventArray.FlightDetail.emailId = details.user.cusEmail; // no encryption
      eventArray.FlightDetail.mobileNumber = details.user.cusMobile; // no encryption
      // eventArray['FlightDetail']['special_fare'] =  'Dynamic';
      // eventArray['FlightDetail']['special_assistance'] =  'Dynamic';
    } else {
      eventArray.FlightDetail.userType = GUEST_USER;
    }
    return eventArray;
  }
  if (eventName === event.SIGNUP_SUCCESS) {
    eventArray.event = event.SIGNUP_SUCCESS;
  }
  if (eventName === event.LOGIN_SUCCESS) {
    eventArray.event = event.LOGIN_SUCCESS;
    eventArray.customerId = details?.user.cusLoyaltyId;
    eventArray.first_name = details?.user.cusFName;
    eventArray.last_name = details?.user.cusLName;
    eventArray.emailId = details?.user.cusEmail;
    eventArray.gender = details?.user.cspGender === "M" ? "Male" : "Female";
    eventArray.mobile_number = details?.user.cusMobileCountryCode + details?.user.cusMobile;
    eventArray.dob = details?.user.cspCustomerBirthday?.split("-")?.reverse()?.join("/");
  }
  if (eventName === event.LOGOUT_SUCCESS) {
    eventArray.event = event.LOGOUT_SUCCESS;
  }

  return eventArray;
}

export function GA4Implementation({
  page = "",
  section = "",
  eventName = "",
  actionType = "",
  value = "",
  details = {}
}) {
  if (typeof window !== "undefined" && typeof window.dataLayer !== "undefined") {
    if (eventName === event.FLIGHT_LISTING) {
      if (details.destination) {
        const resposne = restructureObj(eventName, details);
        if (resposne.pageurl != "/booking") {
          window.dataLayer.push(resposne);
        }
      }
    } else if (eventName === event.FLIGHT_SELECT) {
      dataLayer.push({ ecommerce: null });
      const resposne = restructureObj(eventName, details);
      window.dataLayer.push(resposne);
    } else if (eventName === event.BOOKING_INITIATED) {
      const resposne = restructureObj(eventName, details);
      window.dataLayer.push(resposne);
    } else if (eventName === event.ADD_PAX_DETAILS) {
      // let resposne = restructureObj(eventName, details);
      // window.dataLayer.push(resposne);
    } else if (eventName === event.FLIGHT_SEAT_SELECTED) {
      // let resposne = restructureObj(eventName, details);
      // window.dataLayer.push(resposne);
    } else if (eventName === event.PAYMENT_INITIATED) {
      const resposne = restructureObj(eventName, details);
      window.dataLayer.push(resposne);
    } else if (
      eventName === event.BOOKING_SUCCESSFUL ||
      eventName === event.MANAGE_BOOKING_ADDONS_ADDED ||
      eventName === event.CHECKIN_SUCCESSFULL
    ) {
      const resposne = restructureObj(eventName, details);
      window.dataLayer.push(resposne);
    } else if (eventName === event.SIGNUP_SUCCESS) {
      const resposne = restructureObj(eventName, details);
      window.dataLayer.push(resposne);
    } else if (eventName === event.LOGIN_SUCCESS) {
      const resposne = restructureObj(eventName, details);
      window.dataLayer.push(resposne);
    } else if (eventName === event.LOGOUT_SUCCESS) {
      const resposne = restructureObj(eventName, details);
      window.dataLayer.push(resposne);
    } else {
      // window.dataLayer.push({
      //     page,
      //     section,
      //     eventName,
      //     actionType,
      //     value ,
      //     details
      // })
    }
  }
}
